__turbopack_context__.v({
  "player": "_5_D3TW_player",
  "videoEmbed": "_5_D3TW_videoEmbed",
  "videoEmbedWeb3Theme": "_5_D3TW_videoEmbedWeb3Theme",
});
